import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import Loader, { ErrorBox } from '../../components/Loader.jsx';
import RoutineTaskForm from './RoutineTaskForm.jsx';
import { RoutineTasksAPI } from '../../lib/api';
import { buildPath } from '../../config';

/**
 * "Edit routine task" page.  Loads the row first, then renders
 * ``RoutineTaskForm`` pre-filled with it.
 */
export default function RoutineTaskEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    RoutineTasksAPI.retrieve(id)
      .then((row) => !cancelled && setInitial(row))
      .catch((e) => !cancelled && setLoadError(e))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [id]);

  const onSubmit = (payload) => {
    setSubmitting(true);
    setSubmitError(null);
    RoutineTasksAPI.update(id, payload)
      .then(() => navigate(buildPath.routineTasks()))
      .catch((e) => setSubmitError(e))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <PageHeader
        title={initial ? `Edit: ${initial.title}` : 'Edit Routine Task'}
        subtitle={
          initial?.schedule_summary
            ? `Currently fires ${initial.schedule_summary.toLowerCase()}.`
            : 'Update the schedule or details of this routine.'
        }
      />

      {loading ? (
        <Loader />
      ) : loadError ? (
        <ErrorBox error={loadError} />
      ) : (
        <RoutineTaskForm
          initial={initial}
          submitting={submitting}
          error={submitError}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
}
